import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginatorIntl, Sort } from '@angular/material';
import { LicenseDialogueComponent } from '../license-dialogue/license-dialogue.component';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ViewChild } from '@angular/core';
import { ParemployeeDelDialogComponent } from '../paremployee-del-dialog/paremployee-del-dialog.component';
import { ParemployeeDocumentUploadDialogComponent } from '../paremployee-document-upload-dialog/paremployee-document-upload-dialog.component';
import { ParemployeeDocumentDeleteDialogComponent } from '../paremployee-document-delete-dialog/paremployee-document-delete-dialog.component';
import * as moment from 'moment';
import { PageEvent } from '@angular/material';

@Component({
  selector: 'app-paremployee-documents-tab',
  templateUrl: './paremployee-documents-tab.component.html',
  styleUrls: ['./paremployee-documents-tab.component.css']
})
export class ParemployeeDocumentsTabComponent implements OnInit {
  DocListErr: boolean = false;
  DocListErrMsg;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  public documentType: any;
  public selectedDocumentType: any;
  noResults: any;
  ispaginationFlag: boolean;
  sortedData;
  pageSize = 10;
  public fxDisplay: any = 100;
  length: any;
  getAllEmployeeDocumentData: any[] = [];
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'FileEdit'];
  message: string;
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public employeeId: any;
  getAllPAREmployeeDataById: any[] = [];
  getAllPAREmployeeDocumentsType: any[] = []
  dataSource: MatTableDataSource<DocumentData>;
  docCategory: any;
  uploadedFileName;
  emp_id;
  placeholder = "Select a Document";
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  pageEvent: PageEvent;
  agentDetails: boolean = false;
  constructor(public dialog: MatDialog, private parEmployeeService: ParEmployeeService) { }

  ngOnInit() {
    this.uploadedFileName = 'PAR Employee - PAR North America';
    this.emp_id = localStorage.getItem('Employee_Id');
    this.employeeId = localStorage.getItem('ParEmployeeID');
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    this.getAllPAREmployeeDocuments();
    this.parEmployeeService.getParEmployeeDocumentType().subscribe(res => {
      this.getAllPAREmployeeDocumentsType = res.DocumentTypes;
      this.docCategory = this.getAllPAREmployeeDocumentsType[0].Category;
    }, err => {
      this.DocListErrMsg = "PAR Employee Documents" + err;
      this.DocListErr = true;
    });
    this.subscription = this.parEmployeeService.load.subscribe(res => {
      if (res === 'success') {
        this.getAllPAREmployeeDocuments();
      }
      this.getAllPAREmployeeDocuments();
    });
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
      this.fxDisplay = 50;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
      this.fxDisplay = 100;
    }
  }

  getAllPAREmployeeDocuments() {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    if (roleVal === 8) {
      this.parEmployeeService.getParEmployeeDocumentsBy_EmpId(this.emp_id).subscribe(res => {
        if (res.Documents !== undefined && res.Documents.length <= 0) {
          this.getAllPAREmployeeDataById = [];
          this.dataSource = null;
          this.ispaginationFlag = false;
          this.message = 'No documents Found';
        } else {
          this.getAllPAREmployeeDataById = res.Documents;
          for (let i = 0; i < this.getAllPAREmployeeDataById.length; i++) {
            if (this.getAllPAREmployeeDataById[i].UploadedTimeStamp != '' && this.getAllPAREmployeeDataById[i].UploadedTimeStamp != null && this.getAllPAREmployeeDataById[i].UploadedTimeStamp != undefined) {
              var momentDate = moment(this.getAllPAREmployeeDataById[i].UploadedTimeStamp).format('YYYY/MM/DD');
              this.getAllPAREmployeeDataById[i].UploadedTimeStamp = momentDate;
            }
            if (this.getAllPAREmployeeDataById[i].ExpirationDate !== '' && this.getAllPAREmployeeDataById[i].ExpirationDate !== null && this.getAllPAREmployeeDataById[i].ExpirationDate !== undefined) {
              var momentDate = moment(this.getAllPAREmployeeDataById[i].ExpirationDate).format('YYYY/MM/DD');
              this.getAllPAREmployeeDataById[i].ExpirationDate = momentDate;
            }
          }
          this.message = '';
          this.dataSource = new MatTableDataSource(this.getAllPAREmployeeDataById);
          this.length = this.getAllPAREmployeeDataById.length;
          if (this.length <= 10) {
            this.ispaginationFlag = false;
          } else {
            this.ispaginationFlag = true;
          }
          this.paginator.pageIndex = 0;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';
          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < length ?
              Math.min(startIndex + pageSize, length) :
              startIndex + pageSize;
            const round = Math.ceil(length / 10);
            return `${(startIndex / 10) + 1}  of ${round}`;
          };
          this.dataSource.paginator._intl = paginatorIntl;
        }
      }, err => {
        this.DocListErrMsg = "PAR Employee Documents Type" + err;
        this.DocListErr = true;
      });
    } else {
      this.parEmployeeService.getParEmployeeDocumentsBy_EmpId(this.employeeId).subscribe(res => {
        if (res.Documents !== undefined && res.Documents.length <= 0) {
          this.getAllPAREmployeeDataById = [];
          this.dataSource = null;
          this.ispaginationFlag = false;
          this.message = 'No documents Found';
        } else {
          this.getAllPAREmployeeDataById = res.Documents;
          for (let i = 0; i < this.getAllPAREmployeeDataById.length; i++) {
            if (this.getAllPAREmployeeDataById[i].UploadedTimeStamp != '' && this.getAllPAREmployeeDataById[i].UploadedTimeStamp != null && this.getAllPAREmployeeDataById[i].UploadedTimeStamp != undefined) {
              var momentDate = moment(this.getAllPAREmployeeDataById[i].UploadedTimeStamp).format('YYYY/MM/DD');
              this.getAllPAREmployeeDataById[i].UploadedTimeStamp = momentDate;
            }
            if (this.getAllPAREmployeeDataById[i].ExpirationDate !== '' && this.getAllPAREmployeeDataById[i].ExpirationDate !== null && this.getAllPAREmployeeDataById[i].ExpirationDate !== undefined) {
              var momentDate = moment(this.getAllPAREmployeeDataById[i].ExpirationDate).format('YYYY/MM/DD');
              this.getAllPAREmployeeDataById[i].ExpirationDate = momentDate;
            }
          }
          this.message = '';
          this.dataSource = new MatTableDataSource(this.getAllPAREmployeeDataById);
          this.length = this.getAllPAREmployeeDataById.length;
          if (this.length <= 10) {
            this.ispaginationFlag = false;
          } else {
            this.ispaginationFlag = true;
          }
          this.paginator.pageIndex = 0;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';
          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < length ?
              Math.min(startIndex + pageSize, length) :
              startIndex + pageSize;
            const round = Math.ceil(length / 10);
            return `${(startIndex / 10) + 1}  of ${round}`;
          };
          this.dataSource.paginator._intl = paginatorIntl;
        }
      }, err => {
        this.DocListErrMsg = "PAR Employee Documents" + err;
        this.DocListErr = true;
      });
    }
  }

  placeholderChange()
  {
    this.placeholder = "Document"
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  // Delete Documents
  deleteDoc(data) {
    data.DocumentCategory = this.docCategory;
    const dialogRef = this.dialog.open(ParemployeeDocumentDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: { DocumentData: data }
    });
  }

  doctypeChange(docName) {
    this.openDialog(docName, 'create');
  }

  fileEdit(docName) {
    
    this.openDialog(docName, 'update');
    localStorage.setItem('old', JSON.stringify(docName));

  }

  openDialog(doc, type): void {
    doc.DocumentCategory = this.docCategory;
    var new_Data = {
      DocumentTypeCode: doc.DocumentTypeCode,
      DocumentTypeName: doc.DocumentTypeName,
      DocumentCategory: doc.DocumentCategory
    };
    let dialogRef = this.dialog.open(ParemployeeDocumentUploadDialogComponent, {
      width: '600px',
      height: '500px',
      data: { data: type === 'update' ? doc : new_Data, type: type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedDocumentType = '';
      this.placeholder = "Select a Document"
    });
  }
}

export interface DocumentData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  FileEdit: any;
}




// WEBPACK FOOTER //
// ./src/app/components/paremployee-documents-tab/paremployee-documents-tab.component.ts